import { useTranslation } from '@pancakeswap/localization'
import { Box, Text } from '@pancakeswap/uikit'
import Select, { OptionProps } from 'components/Select/Select'
import useLocalDispatch from 'contexts/LocalRedux/useLocalDispatch'
import { setLeaderboardFilter } from 'state/predictions'
import styled from 'styled-components'

import AddressSearch from '../AddressSearch'

const SearchWrapper = styled(Box)`
  margin-bottom: 8px;
  order: 1;
  /*  */
  width: 426px;

  max-width: 100%;
  margin-bottom: 0;
  ${({ theme }) => theme.mediaQueries.lg} {
    margin-bottom: 0;
    order: 2;
  }
`
const FilterWrapper = styled(Box)`
  order: 2;
  width: 100%;

  ${({ theme }) => theme.mediaQueries.lg} {
    order: 1;
    width: auto;
  }
`

const Filters = () => {
  const { t } = useTranslation()
  const dispatch = useLocalDispatch()
  // const { token } = useConfig()

  const orderByOptions = [
    { label: t('PnL'), value: `netETH` },
    { label: t('Rounds Played'), value: 'totalBets' },
    { label: t('Total FTM'), value: `totalETH` },
    { label: t('Win Rate'), value: 'winRate' },
  ]

  const handleOrderBy = (option: OptionProps) => {
    dispatch(setLeaderboardFilter({ orderBy: option.value }))
  }

  return (
    <Container>
      <div>
        <Text
          className="Label"
          height="48px"
          style={{ whiteSpace: 'nowrap' }}
          textTransform="uppercase"
          fontSize="14px"
          color="#FFFFFF99"
        >
          {t('Rank By')}
        </Text>

        <FilterWrapper>
          <Select options={orderByOptions} onOptionChange={handleOrderBy} />
        </FilterWrapper>
      </div>

      <SearchWrapper>
        <AddressSearch />
      </SearchWrapper>
    </Container>
  )
}
const Container = styled.div`
  padding-top: 1px;
  padding-bottom: 40px;
  width: 1368px;
  max-width: 100%;
  padding-left: 24px;
  padding-right: 24px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  > div:first-child {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .Label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid transparent;
    border-radius: 8px;
    transition: border-radius 0.15s;
    font-size: 14px;
    font-weight: 400;
    line-height: 120%;
    margin-top: 1px;
  }

  @media screen and (max-width: 700px) {
    padding-left: 16px;
    padding-right: 16px;
    flex-direction: column;
    gap: 16px;
    padding-bottom: 32px;
  }
`
export default Filters
